// import * as types from './mutation-type'
export default {
  setUser(state, bol) {
    state.userInfo = bol
  },
  setChannel(state, id) {
    state.channel = id
  },
  setFlowNo(state, flowNo) {
    state.flowNo = flowNo
  }
}
